export default "__VITE_ASSET__B3FS$r3T__"